import { render, staticRenderFns } from "./ProjTab.vue?vue&type=template&id=3e4606a6&"
import script from "./ProjTab.vue?vue&type=script&lang=js&"
export * from "./ProjTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports